import { apiUrl } from "../../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateScheduledDelivery = createAsyncThunk(
  "scheduledDelivery/updateScheduledDelivery",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const deliveryData = {
      ds_id: data.ds_id,
      ds_active: data.ds_active,
      ds_driverID: data.driverID,
      ds_customer_id: data.customerID,
      ds_pickup_id: data.pickup_address,
      ds_dropoff_address: data.dropoff_address,
    };

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(deliveryData),
    };

    try {
      const response = await fetch(
        `${apiUrl}/update_scheduled_package`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Updating scheduled delivery failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const updateScheduledDeliverySlice = createSlice({
  name: "delivery",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    delivery: null,
  },
  reducers: {
    resetUpdateScheduledDeliveryStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateScheduledDelivery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateScheduledDelivery.fulfilled, (state, action) => {
        state.delivery = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(updateScheduledDelivery.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetUpdateScheduledDeliveryStatus } =
  updateScheduledDeliverySlice.actions;
export default updateScheduledDeliverySlice.reducer;
